export class AddVersionHardwareRequirementRequest {
    
    //FKs
    VersionItemID: number; //The version we're associating this requirment with
    HardwareCheckID: number; //Which check are we performing (RAM, CPU, etc)?

    //Values
    MinimumValue : number;
    OptimalValue : number;
    RecommendedValue : number;
    MinimumValueLabel : string;
    OptimalValueLabel : string;
    RecommendedValueLabel : string;
    ScoreWeighting : number;
}
